const subheader = [{"key":"subheader.contribute_button","string":"Dodaj treść"},{"key":"subheader.home","string":"Start"},{"key":"subheader.start","string":"Platforma Ekspercka"},{"key":"subheader.contribute","string":"Dodaj treść"},{"key":"subheader.confirm_account","string":"Potwierdź konto"},{"key":"subheader.reset_password","string":"Resetuj hasło"},{"key":"subheader.knowledge_repository","string":"Repozytorium Wiedzy"},{"key":"subheader.yellow_pages","string":"Baza Kontaktów"}]

export default subheader



// WEBPACK FOOTER //
// ./src/i18n/pl/subheader/_subheader.js